import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CommentaryItemInterface } from 'projects/shared/src/lib/core/interfaces';
import { MomentPipe } from 'projects/shared/src/lib/core/pipes';
import { UserService } from 'projects/shared/src/lib/core/services/user.service';


@Component({
    selector: 'app-comentaries-item',
    imports: [CommonModule, MomentPipe],
    templateUrl: './commentaries-item.component.html',
    styleUrls: ['./commentaries-item.component.scss']
})
export class CommentariesItemComponent {
  @Input() commentary!: CommentaryItemInterface;

  constructor(public userService: UserService) {}
}
